export const RESET_MARK_ORDER_STATE = {
  orderNo: null,
  loaderStatus: false,
  dialogToggle: false,
  packageId: null,
  showCheckerSection: false,
  openCancelDialog: false,
};
